/**
 * Lather & Wood Shaving Co. - "A Better Shave Starts Here" Landing Page Interactions
 * Handles Starter Kit bundle assembly, scent/finish toggling, direct AJAX cart additions,
 * and seamless theme cart-drawer opening.
 */
(function () {
  'use strict';

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function $$(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  var isSubmitting = false;

  function postToCart(items, button, feedbackEl) {
    if (isSubmitting) return;
    if (!items || !items.length) return;
    isSubmitting = true;

    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', 'true');
    }
    if (feedbackEl) {
      feedbackEl.className = 'fl-cart-feedback';
      feedbackEl.textContent = '';
      feedbackEl.style.display = 'none';
    }

    var drawerEl = $('cart-drawer');
    var drawerSectionId = drawerEl ? drawerEl.getAttribute('data-section-id') || 'cart-drawer' : 'cart-drawer';
    var sectionsToBundle = [drawerSectionId];
    var mainCart = $('main-cart');
    if (mainCart) {
      var mainSectionId = mainCart.getAttribute('data-section-id');
      if (mainSectionId && sectionsToBundle.indexOf(mainSectionId) === -1) {
        sectionsToBundle.push(mainSectionId);
      }
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript, application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (parsed) {
          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || parsed.message || 'Could not add to cart.');
          }
          return parsed;
        });
      })
      .then(function (parsed) {
        return fetch(cartUrl, {
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            cart.sections = parsed.sections;

            // Notify Concept theme subscribers
            if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                cart: cart
              });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));

            // Open theme slide-out drawer
            var drawer = $('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }

            if (feedbackEl) {
              feedbackEl.className = 'fl-cart-feedback is-success';
              feedbackEl.textContent = 'Added to your cart!';
              feedbackEl.style.display = 'block';
              setTimeout(function () {
                feedbackEl.style.display = 'none';
              }, 4000);
            }
          });
      })
      .catch(function (error) {
        if (feedbackEl) {
          feedbackEl.className = 'fl-cart-feedback is-error';
          feedbackEl.textContent = error.message || 'Unable to add items to cart. Please try again.';
          feedbackEl.style.display = 'block';
        }
      })
      .finally(function () {
        isSubmitting = false;
        if (button) {
          button.removeAttribute('aria-busy');
          button.removeAttribute('disabled');
        }
      });
  }

  function initStarterKits() {
    // 1. Complete Kit Scent Selection
    var completeCard = $('[data-kit-type="complete"]');
    if (completeCard) {
      $$('[data-scent-choice]', completeCard).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-scent-choice]', completeCard).forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          var scent = btn.getAttribute('data-scent-choice');
          var scentLabel = $('.fl-scent-label', completeCard);
          if (scentLabel) scentLabel.textContent = btn.textContent.trim();

          // Scent mapping updates data attributes
          var soapVariant = btn.getAttribute('data-soap-variant');
          var balmVariant = btn.getAttribute('data-balm-variant');
          var oilVariant = btn.getAttribute('data-oil-variant');

          if (soapVariant) completeCard.setAttribute('data-var-soap', soapVariant);
          if (balmVariant) completeCard.setAttribute('data-var-balm', balmVariant);
          if (oilVariant) completeCard.setAttribute('data-var-oil', oilVariant);
        });
      });

      // Finish Selection
      $$('[data-finish-choice]', completeCard).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-finish-choice]', completeCard).forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          var finishLabel = $('.fl-finish-label', completeCard);
          var nameSpan = $('.fl-finish-name', btn);
          if (finishLabel && nameSpan) finishLabel.textContent = nameSpan.textContent.trim();

          var razorVariant = btn.getAttribute('data-razor-variant');
          if (razorVariant) completeCard.setAttribute('data-var-razor', razorVariant);
        });
      });

      // Add Complete Kit to Cart
      var completeAddBtn = $('[data-add-complete-kit]', completeCard);
      if (completeAddBtn) {
        completeAddBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var soapId = parseInt(completeCard.getAttribute('data-var-soap'), 10);
          var brushId = parseInt(completeCard.getAttribute('data-var-brush'), 10);
          var razorId = parseInt(completeCard.getAttribute('data-var-razor'), 10);
          var oilId = parseInt(completeCard.getAttribute('data-var-oil'), 10);
          var balmId = parseInt(completeCard.getAttribute('data-var-balm'), 10);

          var feedback = $('[data-kit-feedback]', completeCard);

          var items = [
            {
              id: oilId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'wet-shaving-starter-kit', slot: 'oil' }),
                'Starter Kit': 'The Complete Wet Shaving Starter Kit'
              }
            },
            {
              id: soapId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'wet-shaving-starter-kit', slot: 'soap' }),
                'Starter Kit': 'The Complete Wet Shaving Starter Kit'
              }
            },
            {
              id: brushId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'wet-shaving-starter-kit', slot: 'brush' }),
                'Starter Kit': 'The Complete Wet Shaving Starter Kit'
              }
            },
            {
              id: razorId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'wet-shaving-starter-kit', slot: 'razor' }),
                'Starter Kit': 'The Complete Wet Shaving Starter Kit'
              }
            },
            {
              id: balmId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'wet-shaving-starter-kit', slot: 'balm' }),
                'Starter Kit': 'The Complete Wet Shaving Starter Kit'
              }
            }
          ];

          postToCart(items, completeAddBtn, feedback);
        });
      }
    }

    // 2. Essential Kit Finish Selection
    var essentialCard = $('[data-kit-type="essential"]');
    if (essentialCard) {
      $$('[data-finish-choice]', essentialCard).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-finish-choice]', essentialCard).forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          var finishLabel = $('.fl-finish-label', essentialCard);
          var nameSpan = $('.fl-finish-name', btn);
          if (finishLabel && nameSpan) finishLabel.textContent = nameSpan.textContent.trim();

          var razorVariant = btn.getAttribute('data-razor-variant');
          if (razorVariant) essentialCard.setAttribute('data-var-razor', razorVariant);
        });
      });

      // Add Essential Kit to Cart
      var essentialAddBtn = $('[data-add-essential-kit]', essentialCard);
      if (essentialAddBtn) {
        essentialAddBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var soapId = parseInt(essentialCard.getAttribute('data-var-soap'), 10);
          var brushId = parseInt(essentialCard.getAttribute('data-var-brush'), 10);
          var razorId = parseInt(essentialCard.getAttribute('data-var-razor'), 10);

          var feedback = $('[data-kit-feedback]', essentialCard);

          var items = [
            {
              id: soapId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'essential-wet-shaving-kit', slot: 'soap' }),
                'Starter Kit': 'The Essential Wet Shaving Starter Kit'
              }
            },
            {
              id: brushId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'essential-wet-shaving-kit', slot: 'brush' }),
                'Starter Kit': 'The Essential Wet Shaving Starter Kit'
              }
            },
            {
              id: razorId,
              quantity: 1,
              properties: {
                _fudge: JSON.stringify({ offer: 'essential-wet-shaving-kit', slot: 'razor' }),
                'Starter Kit': 'The Essential Wet Shaving Starter Kit'
              }
            }
          ];

          postToCart(items, essentialAddBtn, feedback);
        });
      }
    }
  }

  function initBestsellers() {
    $$('[data-bestseller-card]').forEach(function (card) {
      // Razor finish toggle if card has options
      $$('[data-razor-finish-option]', card).forEach(function (pill) {
        pill.addEventListener('click', function () {
          $$('[data-razor-finish-option]', card).forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-pressed', 'true');

          var vId = pill.getAttribute('data-variant-id');
          var addBtn = $('[data-add-single-item]', card);
          if (addBtn && vId) {
            addBtn.setAttribute('data-variant-id', vId);
          }
        });
      });

      // Bowl color toggle if card has options
      $$('[data-bowl-option]', card).forEach(function (pill) {
        pill.addEventListener('click', function () {
          $$('[data-bowl-option]', card).forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-pressed', 'true');

          var vId = pill.getAttribute('data-variant-id');
          var addBtn = $('[data-add-single-item]', card);
          if (addBtn && vId) {
            addBtn.setAttribute('data-variant-id', vId);
          }
        });
      });

      var addBtn = $('[data-add-single-item]', card);
      var feedback = $('[data-card-feedback]', card);
      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var variantId = parseInt(addBtn.getAttribute('data-variant-id'), 10);
          if (!variantId) return;

          postToCart([{ id: variantId, quantity: 1 }], addBtn, feedback);
        });
      }
    });
  }

  function initSmoothScroll() {
    $$('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        var target = $(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  var initialized = false;
  function initAll() {
    if (initialized) return;
    initialized = true;
    initStarterKits();
    initBestsellers();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
